export function MoneyWithWings(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            width="1em"
            height="1em"
            {...props}
        >
            <g fill="none">
                <path
                    fill="#E6E6E6"
                    d="M12.01 12.44H9.33v-.03H7.64a1.856 1.856 0 0 1-1.857-1.759A1.856 1.856 0 0 1 4.35 8.88A1.86 1.86 0 0 1 3 7.09h9.01c1.48 0 2.68 1.2 2.68 2.68s-1.2 2.67-2.68 2.67"
                ></path>
                <path
                    fill="#D3D3D3"
                    d="M9.492 7.09h-.016v1.516H5.174c-1.064 0-1.945-.651-2.132-1.516h-.037c0 .851.567 1.566 1.345 1.788a1.856 1.856 0 0 0 1.433 1.773A1.856 1.856 0 0 0 7.64 12.41h3.69v-.344H7.64a1.86 1.86 0 0 1-1.804-1.403q.181.036.374.037H9.9v-.344H6.21A1.856 1.856 0 0 1 4.39 8.89q.227.06.474.06h4.627z"
                ></path>
                <path
                    fill="#008463"
                    d="M29.24 14.4L16.46 27.18c-.68.68-1.79.68-2.47 0L12 25.19a1.75 1.75 0 0 1 0-2.47L24.79 9.95a1.75 1.75 0 0 1 2.47 0l1.99 1.99c.67.67.67 1.78-.01 2.46"
                ></path>
                <path
                    fill="#00F397"
                    d="M27.3 12.46L14.52 25.24c-.68.68-1.79.68-2.47 0l-7.49-7.49a1.75 1.75 0 0 1 0-2.47L17.35 2.51a1.75 1.75 0 0 1 2.47 0L27.3 10c.68.68.68 1.78 0 2.46"
                ></path>
                <path
                    fill="#008463"
                    d="M17.809 4.289a1.19 1.19 0 0 1 1.674 0v.002l5.938 5.938a1.183 1.183 0 0 1-.01 1.672l-11.42 11.42a1.19 1.19 0 0 1-1.673 0l-.002-.002l-5.937-5.938a1.19 1.19 0 0 1 0-1.674h.002zm2.188-.52a1.923 1.923 0 0 0-2.706.002l-11.43 11.42l-.002.002a1.923 1.923 0 0 0 .002 2.706l5.94 5.94l.002.002a1.923 1.923 0 0 0 2.706-.002l11.42-11.42a1.914 1.914 0 0 0 .01-2.708l-5.94-5.94zm2.133 7.321a3.41 3.41 0 1 1-6.82 0a3.41 3.41 0 0 1 6.82 0"
                ></path>
                <path
                    fill="#FFF478"
                    d="m12.656 7.2l-3.118 3.12l11.886 11.886l3.118-3.118z"
                ></path>
                <path
                    fill="#FFB02E"
                    d="m22.61 17.162l-3.12 3.118l1.938 1.938l3.118-3.119z"
                ></path>
                <path
                    fill="#fff"
                    d="M9.65 14.647a.377.377 0 1 0-.54.527l.517.53c-.432.57-.466 1.13-.345 1.578a2 2 0 0 0 .388.744a1 1 0 0 0 .135.134q.057.048.159.116c.133.087.33.19.573.25c.513.125 1.173.038 1.83-.619c.24-.24.458-.347.64-.39a1 1 0 0 1 .511.017c.157.045.29.119.386.184c.072.049.135.11.177.186c.046.084.099.203.126.344c.05.262.024.647-.414 1.085c-.437.437-.823.461-1.088.41a1.2 1.2 0 0 1-.443-.188l-.02-.015l-.003-.002a.377.377 0 0 0-.479.584l.002.001l.005.004l.015.012l.046.034q.06.042.162.1c.135.075.33.163.57.21c.425.083.954.03 1.486-.37l.586.592a.377.377 0 0 0 .537-.53l-.59-.597c.394-.527.45-1.05.37-1.471a2 2 0 0 0-.207-.568a1.26 1.26 0 0 0-.415-.446a2.2 2.2 0 0 0-.598-.284a1.75 1.75 0 0 0-.895-.027c-.336.08-.675.265-1 .591c-.474.473-.864.481-1.118.42a1.1 1.1 0 0 1-.341-.15a.7.7 0 0 1-.198-.198a1.2 1.2 0 0 1-.166-.36c-.072-.266-.071-.661.396-1.128s.867-.472 1.142-.4a1.3 1.3 0 0 1 .49.255l.003.003a.378.378 0 0 0 .518-.549h-.001l-.002-.002l-.005-.005l-.014-.013l-.047-.04a2 2 0 0 0-.752-.38c-.448-.116-1.01-.082-1.577.345z"
                ></path>
                <path
                    fill="#E6E6E6"
                    d="M20.08 23.74v-2.68c0-1.48 1.19-2.68 2.67-2.68s2.68 1.2 2.68 2.68v9.01c-.853 0-1.57-.57-1.79-1.35a1.856 1.856 0 0 1-1.771-1.433a1.856 1.856 0 0 1-1.759-1.857v-1.69z"
                ></path>
                <path
                    fill="#D3D3D3"
                    d="M20.454 25.43c0 .872.595 1.601 1.403 1.804a2 2 0 0 1-.037-.374v-3.69h.344v3.69c0 .895.626 1.639 1.466 1.819q-.06-.227-.06-.474v-4.627h1.86v.016h-1.516v4.302c0 1.064.651 1.945 1.516 2.132v.037a1.86 1.86 0 0 1-1.788-1.345a1.856 1.856 0 0 1-1.773-1.433a1.856 1.856 0 0 1-1.759-1.857v-3.69h.344z"
                ></path>
            </g>
        </svg>
    )
}